import { useEffect, useMemo, useState } from 'react';
import { MyAccountPages, MyAccountPageTitles } from '../types/accounts/MyAccount';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';
import { CookieService } from '../CookieService';

export const useMyAccountLinks = () => {
  const { optimizely } = useOptimizely();
  const [flagEnabled, setFlagEnabled] = useState<boolean | null>(null);
  const pianoCookie = CookieService.get('pianoUid') || '';

  useEffect(() => {
    if (!optimizely) {
      return;
    }

    let mounted = true;

    const evaluateFlag = async () => {
      await optimizely.onReady();

      const enabled = optimizely.isFeatureEnabled(
        'save_article_feature',
        pianoCookie
      );

      if (mounted) {
        setFlagEnabled(enabled);
      }
    };

    evaluateFlag();

    return () => {
      mounted = false;
    };
  }, [optimizely, pianoCookie]);

  const baseLinks = [
    {
      href: '/account/my-profile/',
      id: MyAccountPages.Profile,
      label: MyAccountPageTitles[MyAccountPages.Profile],
    },
    {
      href: '/account/subscriptions/',
      id: MyAccountPages.Subscriptions,
      label: MyAccountPageTitles[MyAccountPages.Subscriptions],
    },
    {
      href: '/account/billing/',
      id: MyAccountPages.Billing,
      label: MyAccountPageTitles[MyAccountPages.Billing],
    },
    {
      href: '/my-account/newsletters/',
      id: MyAccountPages.Newsletters,
      label: MyAccountPageTitles[MyAccountPages.Newsletters],
    },
  ];

  const links = useMemo(() => {
    return flagEnabled
      ? [...baseLinks, { href: '/account/my-content/', id: MyAccountPages.Content, label: MyAccountPageTitles[MyAccountPages.Content] }]
      : baseLinks;
  }, [flagEnabled]);

  return links;
};